import React, { useState } from "react";
import { Modal, Button, Form, Table, Alert, ProgressBar } from "react-bootstrap";
import { Text } from "react-bootstrap-text";
import { ArrowRightSquare, Check2Square } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { newTransaction, checkTransactionStatus, buyAgainTransaction} from "../actions/airtimetokens";


const Airtime = ({show, onHide, onClose}) => {
  const dispatch = useDispatch();
  const[ numToPay, setNumToPay] = useState('');
  const[ amount, setAmount] = useState('');
  const[ errAmountMsg, setErrAmoutMsg] = useState('');
  const[ errPhoneRecMsg, setErrPhoneRecMsg] = useState('');
  const[ errPhonePayMsg, setErrPhonePayMsg] = useState('');
  const[ classErrNameAmt, setClassErrNameAmt] = useState('');
  const[ classErrNamePay, setClassErrNamePay] = useState('');
  const[ classErrNameRec, setClassErrNameRec] = useState('');
  const[ numRecAirtime, setNumRecAirtime] = useState('');
  const[ loading, setLoading] = useState(false);

  const doClose = () => {
    //console.log("closing")
    setLoading(false); 
    //setNumRecAirtime('')
   //setNumToPay('')
    //setAmount('')
    setClassErrNameRec("")
    setErrPhoneRecMsg("")
    setClassErrNameAmt("")
    setErrAmoutMsg("")
    setClassErrNamePay("")
    setErrPhonePayMsg("")
  }

  function validate_phone(phone) {
    var num = parseInt(phone);
    if(isNaN(num)) {
      return false;
    }
    if(phone.length !== 10) {
      return false;
    }
    return true;
  }
  function check_amount(amount) {
    var num = parseInt(amount);
    if(isNaN(num)) {
      return false;
    }
    if(num >= 10 && num < 10000) {
      return true;
    } else {
      return false;
    }

  }
  let  prev_data = JSON.parse(localStorage.getItem('tx_data'));
  function process_response(reply) {
    reply.then(data => {     
       if(data.respCode == 200) { 
          localStorage.setItem('tx_id',data.id)
          var status_type = 1; //wait 3 seconds on server
          dispatch(checkTransactionStatus(data.id,status_type))
          .then(reply => {
                //console.log(reply)
                localStorage.setItem('tx_data',reply.tx_data)
                setLoading(false)

            })

      }
      else {

      }
      
     
  })
  }
  const buy_again = () => {
    setLoading(true);
    let resp = dispatch(buyAgainTransaction(localStorage.getItem('tx_id')))
    
    process_response(resp)

  }

  const postData = () => {

    if(check_amount(amount) === false) {
      setErrAmoutMsg("Enter amount greater than 10 but less than 10000");
      setClassErrNameAmt("is-invalid")
      return
    } else {
      setClassErrNameAmt("")
      setErrAmoutMsg("");
    }
    if(validate_phone(numToPay) === false) {
       setClassErrNamePay("is-invalid")
       setErrPhonePayMsg("Enter a valid phone number eg 0722123456")
       return
    } else {
      setClassErrNamePay("")
      setErrPhonePayMsg("")

    }
    if(validate_phone(numRecAirtime) === false) {
      setClassErrNameRec("is-invalid")
      setErrPhoneRecMsg("Enter a valid phone number eg 0722123456")
      return
   } else {
      setClassErrNameRec("")
      setErrPhoneRecMsg("")

  }
    setLoading(true);
    let resp = dispatch(newTransaction('airtime',{
      "amount": amount,
      "num_pay": numToPay,
      "num_rec": numRecAirtime
    }));
    
    process_response(resp)
       
  }

    return (
      <>
        
        <Modal size="lg" show={show} onHide={onHide}  onExited={doClose}  backdrop="static" keyboard={false}  >
          <Modal.Header closeButton>
            <Modal.Title className="info-head">Buy Airtime for all networks</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Number to receive Airtime</Form.Label>
                <Form.Control className={classErrNameRec} value={numRecAirtime} onChange={e => setNumRecAirtime(e.target.value)} type="number" placeholder="eg 0712345678" />
                <div className="invalid-feedback">{errPhoneRecMsg}</div>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Number to pay for Airtime using Mpesa</Form.Label>
                <Form.Control className={classErrNamePay} value={numToPay} onChange={e => setNumToPay(e.target.value)} type="number" placeholder="eg 0712345678" />
                <div className="invalid-feedback">{errPhonePayMsg}</div>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Enter Amount</Form.Label>
                <Form.Control className={classErrNameAmt} value={amount} onChange={e => setAmount(e.target.value)} type="number" placeholder="eg 100" />
                <div className="invalid-feedback">{errAmountMsg}</div>
                <Form.Text className="text-muted">
                   Click Next below then enter Mpesa PIN when prompted
                </Form.Text>
            </Form.Group>
            { loading ? 
            <Alert key={"primary"} show={loading} variant={"primary"}>Please enter your MPESA PIN when prompted
            <ProgressBar animated variant="success" now={100} />
            </Alert> 
            :
            <Button variant="round-1"  className="cta-btn" onClick={postData} type="button">
              Next{' '}<ArrowRightSquare />
          </Button>
          }
           
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Text>Most recent purchase</Text>
            <Table striped bordered hover >
            <thead>
              <tr>
                <th>Network</th>
                <th>Paying #</th>
                <th>Received #</th>
                <th>Mpesa Ref</th>
                <th>Amount</th>
                <th>Status</th>
                <th>#</th>
              </tr>
            </thead>
            <tbody>
              { prev_data ? 
                <tr>
                <td>{prev_data.network}</td>
                <td>{prev_data.num_pay}</td>
                <td>{prev_data.num_rec}</td>
                <td>{prev_data.mpesa_ref}</td>
                <td>{prev_data.amount}</td>
                <td><Check2Square className="chk" /></td>
                <td><Button variant="round-1" onClick={buy_again} className="cta-btn" >Buy again</Button></td>
                </tr>
                :
                <tr></tr>
              }
            </tbody>
            </Table>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  export default Airtime;